import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';

interface FormSnackbarProps {
  open: boolean;
  message: string;
  severity: 'success' | 'error' | 'warning';
  onClose: () => void;
}

const FormSnackbar: React.FC<FormSnackbarProps> = ({
  open,
  message,
  severity,
  onClose,
}) => (
  <Snackbar
    open={open}
    autoHideDuration={4000}
    onClose={onClose}
    anchorOrigin={{ horizontal: 'center', vertical: 'top' }}
  >
    <Alert
      onClose={onClose}
      severity={severity}
      sx={{ width: '100%' }}
      variant="filled"
    >
      {message}
    </Alert>
  </Snackbar>
);

export default FormSnackbar;
